export default __webpack_public_path__ + "static/media/acae_save.8da15580.svg";